import React from "react";
import ActionButtons from "../../../components/ui/popups/ActionButtons";

// The accept-time disclosure (R-32). Member of the org-flow set beside LeaveOrgConfirm, on the
// same themed ActionButtons popup — not a new pattern. (ShareOrgConfirm, the third member, was
// removed by F-524: pressing Share now sends the request with no second confirmation.)
//
// ⭐ "I Agree", per the rule LeaveOrgConfirm states: the former ShareOrgConfirm said "I Agree"
// because sharing GRANTS access and the wording IS the consent. Accepting grants too — it writes
// the authorization tuple and is the consent basis for the incoming organization — so it belongs
// in that shape, not in Leave's plain consequences shape.
//
// ⛔ Shown ONLY when accepting would replace an organization that already holds the record
// (`acceptReplacesCurrentOrg`). When it would not — which is everyone today — Accept stays a
// single direct tap. That is what keeps the existing flow unchanged and stops this from
// becoming the dialog nobody reads.
type Props = {
  /**
   * The disclosure itself, from `replacementWarning`. Empty string when there is nothing to
   * disclose — the popup stays closed, so the copy and the open state cannot disagree.
   */
  warning: string;
  busy?: boolean;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
};

const AcceptInvitationConfirm: React.FC<Props> = ({ warning, busy, onConfirm, onCancel }) => (
  <ActionButtons
    isOpen={!!warning}
    onClose={onCancel}
    title="Accept this invitation?"
    message={warning}
    actionButtons={[
      {
        text: busy ? "Accepting…" : "I Agree",
        isPrimary: true,
        action: async () => {
          await onConfirm();
        },
      },
      { text: "Cancel", action: onCancel },
    ]}
  />
);

export default AcceptInvitationConfirm;
